import { FaUsers } from 'react-icons/fa';
import TopMembersChart from '../Dashboard/TopMembersChart';
import { useState } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardTopMembers } from '../../../redux/MainAction';

const TopMembersCard = () => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  let lDate = new Date();
  const top = useSelector((state) => state.Webtracker.dashboardTopMembers);
  const [dateRange, setDateRange] = useState('today');

  async function fetchDashboardData() {
    setIsLoading(true);
    setFirstRefresh(true);

    let top = {
      startDate: moment(lDate).format('YYYY-MM-DD'),
      endDate: moment(lDate).format('YYYY-MM-DD'),
    };

    await dispatch(getDashboardTopMembers(top));

    setIsLoading(false);
  }

  const handleDateRangeChange = async (e) => {
    setIsLoading(true);
    const value = e.target.value;
    setDateRange(value);
    let start, end;
    const today = new Date();

    const currentDayOfWeek = today.getDay();
    const monday = new Date(today);
    monday.setDate(today.getDate() - currentDayOfWeek + 1);
    const sunday = new Date(today);
    sunday.setDate(today.getDate() - currentDayOfWeek + 7);

    switch (value) {
      case 'today':
        start = today;
        end = today;
        break;
      case 'thisWeek':
        start = monday;
        end = today;
        break;

      default:
        return;
    }

    let top = {
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    };

    await dispatch(getDashboardTopMembers(top));
    setFirstRefresh(true);

    setIsLoading(false);
  };

  return (
    <div className="col-6">
      <div className="card m-b-20 enhanced-card">
        <div className="d-flex justify-content-between align-items-center border_class">
          <h5 className="dash-card-title  font-20 ml-3">
            <FaUsers className="font-20 mb-1 mr-1 dash-text-primary" /> Top
            Members
          </h5>

          <div className="d-flex align-items-center">
            <select
              className="form-control"
              style={{
                border: '1px solid gray',
                width: '115px',
                cursor: 'pointer',
                marginTop: '10px',
              }}
              value={dateRange}
              onChange={handleDateRangeChange}
            >
              <option value="today">Today </option>
              <option value="thisWeek">This Week</option>
            </select>
          </div>
        </div>

        <div className="card-body dash_cards act_card2">
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="spinner-border text-primary " role="status"></div>
            </div>
          ) : firstRefresh ? (
            top?.length > 0 ? (
              <TopMembersChart members={top} />
            ) : (
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ height: '350px', color: '#96C9F4' }}
              >
                <i className=" mdi mdi-account-multiple font-40"></i>
                <span className="font-14">No Members Found Yet</span>
              </div>
            )
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <button
                className="btn btn-primary font-14"
                onClick={fetchDashboardData}
              >
                Load Data
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopMembersCard;
